import { render, staticRenderFns } from "./CategoriesBlock.vue?vue&type=template&id=003e1be2"
import script from "./CategoriesBlock.vue?vue&type=script&lang=js"
export * from "./CategoriesBlock.vue?vue&type=script&lang=js"
import style0 from "./CategoriesBlock.vue?vue&type=style&index=0&id=003e1be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports